import { createApiInstance } from './index';

const api = createApiInstance();

/**
 * 取得帳戶資訊
 * @param {string} acctUuid
 */
export const getAccountById = (acctUuid) => {
    return api.post('get_account_by_id/', {
      acct_uuid: acctUuid,
    });
  };

// 更新帳戶資訊
export const updateAccount = (payload) => {
  return api.post('update_account/', payload);
};

// 修改密碼
export const changePassword = ({ acct_uuid, old_pwd, new_pwd }) => {
  return api.post('change_password/', { acct_uuid, old_pwd, new_pwd });
};

// 依多個 account uuid 取得帳號
export const getAccountsByNoList = (acctUuidList) => {
  return api.post('get_accounts_by_no_list/', {
    acct_uuid_list: acctUuidList,
  });
};
